/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Digest_Title_TailInputs */

const en_platform_digest_title_tail = /** @type {(inputs: Platform_Digest_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`at 8:00.`)
};

const pl_platform_digest_title_tail = /** @type {(inputs: Platform_Digest_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o 8:00.`)
};

/**
* | output |
* | --- |
* | "at 8:00." |
*
* @param {Platform_Digest_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_digest_title_tail = /** @type {((inputs?: Platform_Digest_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Digest_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_digest_title_tail(inputs)
	return en_platform_digest_title_tail(inputs)
});